import { serverAjaxPromise } from './request_helpers';

const deletePhoto = photoId => {
  return serverAjaxPromise({
    type: 'DELETE',
    url: `/api/alltrails/photos/${photoId}`
  });
};

const suggestDeletePhotoFromTrail = (trailSlug, photoId) => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/trail/${trailSlug}/edit/photos/${photoId}/suggest_delete`
  });
};

const unhidePhoto = photoId => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/api/alltrails/photos/${photoId}/unhide`
  });
};

const removePhotoFromMap = (mapId, photoId) => {
  return serverAjaxPromise({
    type: 'DELETE',
    url: `/api/alltrails/maps/${mapId}/photos/${photoId}`
  });
};

const removePhotoFromTrail = (trailSlug, photoId) => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/trail/${trailSlug}/edit/photos/${photoId}/remove`
  });
};

const setAsMapProfilePhoto = (mapId, photoId) => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/api/alltrails/maps/${mapId}/profile_photo`,
    data: {
      photo_id: photoId
    }
  });
};

const setAsTrailProfilePhoto = (trailSlug, photoId) => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/trail/${trailSlug}/edit/photos/${photoId}/set_default`,
    data: {
      photo_id: photoId
    }
  });
};

const setAsListProfilePhoto = (listId, photoId) => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/api/alltrails/lists/${listId}/profile_photo`,
    data: {
      photo_id: photoId,
      return_photo: true
    }
  });
};

export {
  deletePhoto,
  suggestDeletePhotoFromTrail,
  unhidePhoto,
  removePhotoFromMap,
  removePhotoFromTrail,
  setAsTrailProfilePhoto,
  setAsMapProfilePhoto,
  setAsListProfilePhoto
};
